<template lang="pug">
.tab-heading(@click='clickEvent', :data-active='isActive')
  .tab-heading__label.font-medium
    slot
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

/**
 * 見出しタブ
 */
@Component
export default class TabHeading extends Vue {
  // アクティブフラグ
  @Prop()
  isActive!: boolean

  private clickEvent(key: Event): void {
    // アクティブ時はクリックイベントを実行しない
    if (this.isActive) return

    this.$emit('click', key)
  }
}
</script>

<style lang="stylus" scoped>
.tab-heading
  border-radius 12px 12px 0px 0px
  padding 10px 20px
  cursor pointer

  &:hover
    background-color var(--color-manager-tab-heading-hover__background)

  &[data-active='true']
    background-color var(--color-manager-tab-heading-active__background)
    box-shadow 0px 3px 5px 0px var(--color-manager-tab-heading-active__shadow)
    cursor auto
</style>
